import { useState, useEffect, useCallback } from 'react'

const lensData = [
  {
    name: 'Dulce María',
    image: '/adults/11.webp',
    backgroundColor: '#fce4e4',
    textColor: '#ffffff',
  },
  {
    name: 'LACOSTE',
    image: '/adults/56.webp',
    backgroundColor: '#e4fcfc',
    textColor: '#000000',
  },
  {
    name: 'Bull',
    image: '/adults/63.webp',
    backgroundColor: '#e4fce4',
    textColor: '#ffffff',
  },
  {
    name: 'Fe Vision',
    image: '/adults/38.webp',
    backgroundColor: '#fce4fc',
    textColor: '#000000',
  },
  {
    name: 'Magic Vision',
    image: '/adults/27.webp',
    backgroundColor: '#e4fce4',
    textColor: '#ffffff',
  },
]

const generateRamdomColor = () => {
  const hue = Math.floor(Math.random() * 360)
  return `hsl(${hue}, 80%, 90%)`
}

export const useImageCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [direction, setDirection] = useState(0)
  const [isReserved, setIsReserved] = useState(false)

  const handleNext = useCallback(() => {
    setDirection(1)
    setIsReserved((prev) => !prev)
    setCurrentIndex((prevIndex) => {
      const nextIndex = (prevIndex + 1) % lensData.length
      lensData[nextIndex].backgroundColor = generateRamdomColor()
      return nextIndex
    })
  }, [])

  const handlePrev = useCallback(() => {
    setDirection(-1)
    setIsReserved((prev) => !prev)
    setCurrentIndex((prevIndex) => {
      const nextIndex = (prevIndex - 1 + lensData.length) % lensData.length
      lensData[nextIndex].backgroundColor = generateRamdomColor()
      return nextIndex
    })
  }, [])

  const goToNextSlide = useCallback(() => {
    handleNext()
  }, [handleNext])

  useEffect(() => {
    const timer = setTimeout(() => {
      setDirection(0)
    }, 500)
    return () => clearTimeout(timer)
  }, [currentIndex])

  useEffect(() => {
    const timer = setInterval(() => {
      goToNextSlide()
    }, 5000)

    return () => clearInterval(timer)
  }, [goToNextSlide])

  const currentLens = lensData[currentIndex]

  return { currentIndex, direction, isReserved, currentLens, handlePrev, handleNext, lensData }
}
